<template lang="pug">
    .settings-input-wrapper(:class="{'settings-input-wrapper-mt' : mt}")
        span.settings-input-block-name {{title}}
        input.settings-input(:type="type" :value="value" :pattern="pattern" :max="max" :min="min" :step="step" :placeholder="placeholder" @input="input" @change="change")
        span.settings-input-error {{ error || '' }}
</template>

<script>
export default {
    name: "settings-form-input",
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        title: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default() {
                return 'text'
            }
        },
        pattern: {
            type: String,
            default() {
                return ''
            }
        },
        min: {
            type: Number,
            default() {
                return 0
            }
        },
        max: {
            type: Number,
            default() {
                return 100
            }
        },
        step: {
            type: Number,
            default() {
                return null
            }
        },
        placeholder: {
            type: String,
            default() {
                return ''
            }
        },
        mt: {
            type: Boolean,
            default() {
                return false
            }
        },
        error: {
            type: String,
            default: '',
        },
    },
    methods: {
        input(event) {
            this.$emit('input', event.target.value)
        },
        change(value) {
            this.$emit('change', value)
        }
    }
}
</script>
